import { FormControl, OutlinedInput, OutlinedInputProps, Typography } from '@mui/material';
import { forwardRef } from 'react';
import { IMask, IMaskMixin } from 'react-imask';

interface Props extends OutlinedInputProps {
  labelText?: string;
  maskOptions?: {
    mask: string | Array<string | RegExp> | typeof IMask.Masked | any;
    scale?: number; // digits after point, 0 for integers
    thousandsSeparator?: string; // any single char
    padFractionalZeros?: boolean; // if true, then pads zeros at end to the length of scale
    normalizeZeros?: boolean; // appends or removes zeros at ends
    radix?: string; // fractional delimiter
    mapToRadix?: string[]; // symbols to process as radix
    min?: number;
    max?: number;
    autofix?: boolean;
    maxLength?: number;
    lazy?: boolean;
    onAccept?: (value: string, maskRef: any, event?: unknown) => void;
  };
  errorText?: string;
  helperText?: string;
}

const MaskedInput = IMaskMixin(({ inputRef, ...props }: any) => {
  return <OutlinedInput {...props} inputRef={inputRef} />;
});

const InputField = forwardRef((props: Props, ref) => {
  const { maskOptions, labelText, errorText, helperText, ...rest } = props;
  // Map React Hook Form's field.ref to MUI/IMask inputRef so focus works properly.
  // React 18 strips `ref` from props, so register()'s ref arrives as the forwardRef argument;
  // without it register() can't read the input value.
  const { ref: propRef, ...inputProps } = rest as any;
  const fieldRef = propRef ?? ref;

  return (
    <FormControl fullWidth variant='outlined'>
      <Typography fontSize={14} mb={'8px'}>
        {labelText}
      </Typography>
      {maskOptions ? (
        <MaskedInput {...inputProps} {...maskOptions} inputRef={fieldRef} />
      ) : (
        <OutlinedInput {...inputProps} inputRef={fieldRef} />
      )}
      {helperText && (
        <Typography mt={'3px'} fontSize={13} color={'#b8babc'}>
          {helperText}
        </Typography>
      )}
      {/* Optional | TODO: color will add from theme */}
      {errorText && (
        <Typography mt={'3px'} fontSize={13} color={'#FF5F57'}>
          {errorText}
        </Typography>
      )}
      {/* Optional | color will add from theme */}
    </FormControl>
  );
});

export default InputField;
